const upperCaseFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const plural = (str) => (str.endsWith('y') ? `${str.slice(0, -1)}ies` : `${str}s`);

const singular = (str) => (str.endsWith('ies') ? `${str.slice(0, -3)}y` : str.slice(0, -1));

export { upperCaseFirstLetter, plural, singular };
